import {VmButton, VmText, VmView} from 'components'
import HStack from 'components/HStack'
import vmedisicon from 'assets/vmedisicon.png'
import {fetchCetak, formatCetakJumlah, formatTanggalLahirCetak} from './api'
import trans_bg from 'assets/trans_bg.png'

import moment from 'moment'
import React, {useState} from 'react'
import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {sleep} from 'pages/prd-penjualan-obat-resep/utils'

export default function Cetak() {
  const params = useParams()
  const [data, setdata] = useState({
    detail: {
      head: {
        pjid: '',
      },
      child: [],
    },
  })
  const [imageLoad, setimageLoad] = useState({stempel: false, ttd: false})
  const [isPrinting, setisPrinting] = useState(true)

  const navigate = useNavigate()

  useEffect(() => {
    const init = async () => {
      const resCetak = await fetchCetak(params.uid, params.id)
      setdata(resCetak)
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const exec = async () => {
      setisPrinting(true)
      await sleep(500)
      const ttdEnabled = parseInt(data?.stg?.stgttddokter) !== 0
      const stempelEnabled = parseInt(data?.stg?.stgstempeldokter) !== 0
      const imagesReady =
        (!ttdEnabled || imageLoad.ttd) &&
        (!stempelEnabled || imageLoad.stempel)
      if (data?.detail?.head?.pjid && !data?.e && imagesReady) {
        window.print()
        setisPrinting(false)
      }
    }
    exec()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.detail?.head?.pjid, imageLoad])

  const onImageLoad = type => {
    setimageLoad(prev => (prev[type] ? prev : {...prev, [type]: true}))
  }

  if (data?.e)
    return (
      <VmView className="fixed h-full inset-0 text-center flex items-center">
        <VmText>Terjadi kesalahan saat cetak, silakan coba kembali</VmText>
      </VmView>
    )

  return (
    <>
      <VmView className="m-5">
        <HStack align="start" className="mb-5">
          <img src={vmedisicon} alt="logo" className="w-20 shrink-0" />
          <p className="flex-1 text-center text-sm font-bold self-center">
            Resep Digital
          </p>
          <VmView className="w-20 shrink-0" />
        </HStack>

        <p className="text-sxs font-bold">No. Resep</p>
        <HStack justify="between">
          <p className="text-sxs">{data?.detail?.head.pjnofaktur || '-'}</p>
          <p className="text-sxs">
            {data?.detail?.head?.pjtanggal
              ? moment(data.detail.head.pjtanggal).format(
                  'DD MMM YYYY HH:mm:ss'
                )
              : '-'}
          </p>
        </HStack>

        <VmView className="border-y border-black py-4 my-4 grid grid-cols-2 items-start">
          <VmView>
            <table className="border-none">
              <tbody>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Dokter</p>
                  </td>
                  <td>
                    <p className="text-sxs">
                      {data?.identitas?.nama_lengkap || '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">SIP</p>
                  </td>
                  <td>
                    <p className="text-sxs ">
                      {data?.identitas?.user_nosip || '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Spesialis</p>
                  </td>
                  <td>
                    <p className="text-sxs ">
                      {data?.identitas?.ket_suspend || '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">No. Telp</p>
                  </td>
                  <td>
                    <p className="text-sxs">{data?.identitas?.user_wa || '-'}</p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Alamat</p>
                  </td>
                  <td>
                    <p className="text-sxs">{data?.identitas?.alamat || '-'}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </VmView>

          <VmView>
            <table className="border-none">
              <tbody>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Pasien</p>
                  </td>
                  <td>
                    <p className="text-sxs">
                      {data?.detail?.head?.pasrm
                        ? `${data.detail.head.pasrm} / ${
                            data?.detail?.head?.pasnama || '-'
                          }`
                        : data?.detail?.head?.pasnama || '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">No. WA</p>
                  </td>
                  <td>
                    <p className="text-sxs">
                      {data?.detail?.head?.pastelp || '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Jenis Kelamin</p>
                  </td>
                  <td>
                    <p className="text-sxs ">
                      {data?.detail?.head?.pasjk || '-'}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Tanggal Lahir</p>
                  </td>
                  <td>
                    <p className="text-sxs ">
                      {formatTanggalLahirCetak(data?.detail?.head?.pastgllahir)}
                    </p>
                  </td>
                </tr>
                <tr className="align-top">
                  <td>
                    <p className="text-sxs font-bold mr-2">Alamat</p>
                  </td>
                  <td>
                    <p className="text-sxs ">
                      {data?.detail?.head?.pasalamat || '-'}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </VmView>
        </VmView>

        <HStack className={'mb-4'}>
          <p className="flex-[0.4] text-sxs font-bold">Obat</p>
          <p className="flex-[0.4] text-sxs font-bold mx-2">Aturan Pakai</p>
          <p className="flex-[0.2] text-sxs font-bold">Jumlah</p>
        </HStack>

        {data.detail?.child.length > 0 &&
          data.detail?.child.map((item, i) => (
            <HStack align="start" className={'mb-4'} key={i}>
              <p className="flex-[0.4] text-sxs font-bold">
                {item.pjdnama ? `R/ ${item.pjdnama}` : '-'}
              </p>
              <p className="flex-[0.4] text-sxs mx-2">
                {item.pjdcatatan || '-'}
              </p>
              <p className="flex-[0.2] text-sxs ">{`${formatCetakJumlah(item.pjdjumlah)} ${item.pjdsatuan}`}</p>
            </HStack>
          ))}

        <VmView className="mt-10 pt-4">
          <VmView className="ml-auto mr-16 w-40">
            {(() => {
              const ttd = parseInt(data?.stg?.stgttddokter) !== 0
              const stempel = parseInt(data?.stg?.stgstempeldokter) !== 0
              if (!ttd && !stempel) return null

              return (
                <VmView className="relative mb-1 h-36 w-full overflow-hidden">
                  {stempel && (
                    <img
                      alt="stempel-dokter"
                      className="absolute inset-0 h-full w-full object-contain opacity-25"
                      src={data?.stg?.user_stempel || trans_bg}
                      onLoad={() => onImageLoad('stempel')}
                      onError={() => onImageLoad('stempel')}
                    />
                  )}
                  {ttd && (
                    <img
                      alt="ttd-dokter"
                      className="absolute bottom-0 left-0 right-0 z-10 h-24 w-full object-contain object-bottom"
                      src={data?.stg?.user_ttd || trans_bg}
                      onLoad={() => onImageLoad('ttd')}
                      onError={() => onImageLoad('ttd')}
                    />
                  )}
                </VmView>
              )
            })()}
            <p className="text-center text-xs w-full">
              {data?.identitas?.nama_lengkap}
            </p>
          </VmView>
        </VmView>
      </VmView>

      {!isPrinting && (
        <VmView className="flex justify-end m-5">
          <VmButton color="danger" onClick={() => navigate(-1)}>
            Kembali
          </VmButton>
        </VmView>
      )}
    </>
  )
}
